<template>
  <map-tab />
</template>

<script>
import MapTab from '@/components/Map/Tab'

export default {
  components: {
    MapTab,
  }
}
</script>
